export const DEFAULT_ERROR = 'Ha ocurrido un error, intente nuevamente.';
export const NON_EXISTENT_MCC_ERROR = 'El MCC ingresado no existe. Confirma que lo escribiste correctamente e intenta nuevamente.';
export const MCC_DISABLED_ERROR = 'Este MCC esta deshabilitado. Intente con otro MCC';
